import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { RawDraftContentState } from 'draft-js';

import { IAsset } from 'components/Pages/Admin/shared/ItinerariesItemLanding/Builder/types';

import { IListBlockItemProps } from './types';

export const useItem = (props: IListBlockItemProps) => {
  const { id, data, onChange } = props;
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });

  const styleDndButton = {
    transform: CSS.Translate.toString(transform),
    transition: transform ? transition : undefined,
    userSelect: 'none',
    pointerEvents: isDragging ? 'none' : undefined,
    zIndex: isDragging ? 9999 : undefined,
    opacity: isDragging ? 0.2 : undefined,
  };

  const handleChangeTitle = (title: string) => {
    onChange({ ...data, title });
  };

  const handleChangeDesc = ({ data: wData }: { data: { raw: RawDraftContentState; text: string } }) => {
    onChange({ ...data, desc: { text: wData.text, raw: wData.raw } });
  };

  const handleChangeImage = (image: IAsset) => {
    onChange({ ...data, image });
  };

  return { attributes, listeners, setNodeRef, styleDndButton, handleChangeTitle, handleChangeDesc, handleChangeImage };
};
